import { render, staticRenderFns } from "./employees_info.vue?vue&type=template&id=709c768b&scoped=true&"
import script from "./employees_info.vue?vue&type=script&lang=js&"
export * from "./employees_info.vue?vue&type=script&lang=js&"
import style0 from "./employees_info.vue?vue&type=style&index=0&id=709c768b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c768b",
  null
  
)

export default component.exports